import { LibraryTypes } from "../../../domain/enums";
import { MediaItem } from "../../../domain/media";
import { GraphicsInfo } from "../../../domain/graphics-info";

export class LiveInputModel {
  // public media: MediaItem;
  // public graphic: GraphicsInfo;

  public graphics: [GraphicsInfo];

  constructor(
    public type: string,
    public media?: MediaItem,
    public graphic?: GraphicsInfo,
  ) {}

  /**
   * Return LiveInput Media Type
   * @return {string}
   */
  getType() {
    return this.type;
  }

  /**
   * Return LiveInput Media Model
   * @return {MediaItem}
   */
  getMedia() {
    return this.media;
  }

  getGraphic() {
    return this.graphic;
  }

  /**
   * adding graphic to media item (to be applied)
   * @param graphic
   * @retrun LiveInput
   */
  addAttachedGraphic(graphic: GraphicsInfo) {
    if (!this.graphics) {
      this.graphics = [graphic];
    } else {
      this.graphics.push(graphic);
    }

    return this;
  }

  /**
   * returns the attached graphics
   * @return {any}
   */
  getAttachedGraphic() {
    return this.graphics;
  }

  /**
   * Return Image URL for as Thumbnail
   * @return string
   */
  getThumbnail() {
    return this.isVideoInput()
      ? this.getMedia().contentSnapshotUrl
      : this.getGraphic().thumbnail;
  }

  /**
   * Return Input name
   */
  getName() {
    if (this.isVideoInput()) {
      return this.getMedia().name != null
        ? this.getMedia().name
        : this.getMedia().userFilename;
    }

    return this.getGraphic().name;
  }

  /**
   * Retrun boolean if current is video type
   * @return {boolean}
   */
  isVideoInput() {
    return this.type == LibraryTypes.Video;
  }
}
